import { getValueFromQuery } from 'utils';

type KeyType = 'uid' | 'access-token' | 'client' | 'expiry';

type AuthHeaders = Record<string, unknown>;

function setHeader(data: AuthHeaders, key: KeyType) {
  const value = data[key];
  if (typeof value === 'string' && value) localStorage.setItem(key, value);
}

const authHeaders = ['uid', 'access-token', 'client', 'expiry'];

export function setAuthDataFromQuery(query = '') {
  authHeaders.forEach(key => {
    const headerKeyValue = getValueFromQuery(query, key);
    if (headerKeyValue) localStorage.setItem(key, headerKeyValue);
  });
}

export function setAuthData(data: AuthHeaders) {
  if (data) {
    authHeaders.forEach(headerKey => {
      setHeader(data, headerKey as KeyType);
    });
  }
}

export function getAuthData(): { [key: string]: string } {
  const data = {};
  authHeaders.forEach(key => {
    const headerKeyValue = localStorage.getItem(key);
    if (headerKeyValue) Object.assign(data, { [key]: headerKeyValue });
  });
  return data;
}

export function clearAuthData() {
  console.warn('%c clearAuthData()', 'color: blue');
  authHeaders.forEach(key => {
    localStorage.removeItem(key);
  });
}
